import { Action, createAction } from 'redux-actions';
import { PassengerServices, PassengerState, PassengerValue } from './reducers';
import { SelectedSeatFragment } from '@websky/graphql';

export const SET_PASSENGERS_STATE = 'SET_PASSENGERS_STATE';
export const SET_PASSENGER_VALUES = 'SET_PASSENGER_VALUES';
export const SET_PASSENGER_SERVICES = 'SET_PASSENGER_SERVICES';
export const SET_PASSENGER_SEATS = 'SET_PASSENGER_SEATS';

export type SetPassengerValues = Action<{ id: number; values: PassengerValue[] }>;
export type SetPassengerServicesAction = Action<{ id: number; services: PassengerServices[] }>;
export type SetPassengerSeatsAction = Action<{ id: number; seats: SelectedSeatFragment[] }>;

export const setPassengersState = createAction<PassengerState[]>(SET_PASSENGERS_STATE);

export const setPassengerValues = createAction(SET_PASSENGER_VALUES, (id: number, values: PassengerValue[]) => ({
	id,
	values
}));
